export default "__VITE_ASSET__wtyNU2Fw__"